export const PageCard = ({
  icon: Icon,
  title,
  route,
  purpose,
  children,
}: {
  icon: React.ElementType;
  title: string;
  route: string;
  purpose: string;
  children?: React.ReactNode;
}) => (
  <div className="rounded-sm border border-border bg-card p-4 space-y-3 mb-4">
    <div className="flex items-start gap-3">
      <div className="flex items-center justify-center w-9 h-9 rounded-md bg-primary-tint-soft flex-shrink-0">
        <Icon className="h-5 w-5 text-primary" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="text-sm font-semibold text-foreground">{title}</span>
          <code className="text-[11px] bg-surface-tint-medium px-1.5 py-0.5 rounded text-muted-foreground">{route}</code>
        </div>
        <p className="text-sm text-muted-foreground mt-1">{purpose}</p>
      </div>
    </div>
    {children && <div className="pl-12 space-y-2">{children}</div>}
  </div>
);
